<template>
  <ul :class="['menuList', { root }]">
    <template v-for="({ name, uri: path, icon, children, is_menu, level }, index) in children">
      <li
        v-if="is_menu === '1'"
        :class="['menu-item', `level-${level}`, { active: path === parentPath || path === $route.fullPath || path === $route.meta.active }]"
        :key="index"
      >
        <router-link
          tag="div"
          :to="{ path }"
          class="menu-item__wrap"
        >
          <i
            v-if="icon"
            :class="['menu-icon',icon]"
          ></i>
          <div class="menu-name">{{name}}</div>
        </router-link>
        <tree-menus
          :children="children"
          :root="false"
        ></tree-menus>
      </li>
    </template>
  </ul>
</template>
<script>
export default {
  name: 'treeMenus',

  props: {
    children: {
      type: Array,
      default () {
        return []
      }
    },
    root: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    parentPath () {
      const { path } = this.$route
      const auths = this.$store.state.allPermissions
      const { parent_id } = auths.find(item => item.uri === path) || {}
      if (parent_id) {
        const parent = auths.find(item => item.id === parent_id) || {}
        return parent.uri
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .menuList {
    font-size: 13px;
    &.root > .menu-item > .menu-item__wrap > .menu-name {
      font-size: 14px;
    }
    .menu-item {
      padding: 5px 0;
      line-height: 40px;
      text-align: left;
      color: $--color-menu-default;
      font-weight: bold;
      cursor: pointer;
      &.level-2 {
        line-height: 26px;
        font-weight: normal;
      }
      &.active {
        color: $--color-menu-active;
      }
    }
    .menu-item__wrap {
      @include clearfix;
      &:hover {
        color: mix($--color-menu-active, $--color-white, 90%);
      }
    }
    .menu-icon {
      float: left;
      width: 1.5em;
    }
    .menu-name {
      margin-left: 1.5em;
    }
  }
</style>
